const styles = {
  chip: {
    color: "inherit",
    borderRadius: 2,
  },
};

export default styles;
